<template>
  <div class="columns is-centered">
    <div class="column is-half">
      <h2>Signing Out...</h2>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  async created() {
    await this.$store.dispatch("auth/signOut");
    router.push("/");
  }
};
</script>
